// extracted by mini-css-extract-plugin
export default {"nav_icon":"header_nav_icon__1V7TW","nav_dropdown":"header_nav_dropdown__tW0JT","menu_icon":"header_menu_icon__BFndm","nav_dropdown_item":"header_nav_dropdown_item__uMFsw"};